<template>
  <div class="context-query-container" v-if="de">
    <div class="field-container">
      <label class="query-label">
        {{ messages.OBJECT.Text_vod__c }}
      </label>
      <div class="selection" v-if="de.object">
        {{ de.objectLabel || de.object }}
      </div>
      <div class="selection" v-else></div>
    </div>

    <div class="field-container">
      <label class="query-label">
        {{ $t("fields") }}
      </label>
      <div class="fields-search">
        <div class="selection" v-if="de.selectedField">{{ fieldLabel }}</div>
        <div class="selection" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "ContextQuery",
    props: {
      deId: String,
      appId: String,
      appType: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      de() {
        let elem = this;
        let app = elem.apps.find(app => {
          return app.uuid === elem.appId;
        });

        return app.dataElements[elem.deId];
      },
      fieldLabel() {
        const field =
          this.de.fields && Object.keys(this.de.fields).length
            ? Object.values(this.de.fields)[0]
            : null;
        return field && field.label ? field.label : this.de.selectedField.label;
      }
    }
  };
</script>

<style scoped>
  .context-query-container {
    display: flex;
  }

  .field-container {
    display: flex;
    flex: 1;
    align-items: center;
    padding: 0 1rem;
  }

  .query-label {
    flex: 1;
    max-width: 100px;
    padding-right: 0.5rem;
    margin-bottom: 0;
  }
</style>
